import { useIntl } from 'react-intl';

/* Other */
import { getJsonImage } from 'src/theme/images';

/* Assets */
import InteractiveIcon from '../../assets/svg/interactive-icon.svg?react';

/* Styles */
import './LiveInteractiveTag.scss';

function LiveInteractiveTag() {
  const { formatMessage } = useIntl();
  const interactiveIcon = getJsonImage('interactive-icon');

  return (
    <p className="live-interactive-tag">
      <span className="live-interactive-tag__icon">
        {interactiveIcon ? (
          <img loading="lazy" decoding="async" src={interactiveIcon} alt="interactive icon" />
        ) : (
          <InteractiveIcon />
        )}
      </span>
      <span className="live-interactive-tag__text">
        { formatMessage({ id: 'common.live.interactive.tag' })}
      </span>
    </p>
  );
}

export default LiveInteractiveTag;
